export const ACTIONS = {
  UPDATE_TRACKING_DATA: 'updateTrackingData'
}

export const MUTATIONS = {
  SET_TRACKING_DATA: 'setTrackingData',
  SET_COMPLETED: 'setCompleted'
}
